export enum DataType{
    Number = 1,
    Boolean = 2
  }